import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {UserService} from '../../services/user.service';
import {ToastService} from '../../services/toast.service';
import {ModalController} from '@ionic/angular/lazy';

@Component({
  standalone: false,
  selector: 'app-account-delete',
  templateUrl: './account-delete.component.html',
  styleUrls: ['./account-delete.component.scss'],
})
export class AccountDeleteComponent implements OnInit {

  accountDeleteForm: FormGroup;

  constructor(private userService: UserService,
              public formBuilder: FormBuilder,
              private toast: ToastService,
              private modal: ModalController) {

    this.accountDeleteForm = this.formBuilder.group({
      current_password: ['', [Validators.minLength(8)]],
    }, {});

  }

  ngOnInit() {}

  cancel() {
    this.modal.dismiss(null, 'cancel');
  }

  onAccountDelete() {
    this.userService.deleteAccount(this.accountDeleteForm.value.current_password).then(
      x => {
        this.cancel();
      }
    );
  }

}
